var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.2 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19 18.4-4.9-4.9c1.3-1.4 2-3.3 2-5.3C16.1 3.8 12.5.1 8 .1c-4.4-.1-8 3.5-8 8 0 4.4 3.6 8.1 8.1 8.1 2.1 0 3.9-.8 5.3-2l4.9 4.9c.1.1.2.1.3.1s.2 0 .3-.1c.3-.3.3-.6.1-.7M8.1 15.2C4.2 15.2 1 12 1 8.1S4.2 1 8.1 1s7.1 3.2 7.1 7.1c0 1.8-.7 3.4-1.8 4.7l-.2-.2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l.2.2c-1.2 1-2.8 1.7-4.6 1.7"
  })));
};
export default SvgSearch;